
    import Vue from 'vue';
    import RomaNotification from "../components/commons/RomaNotification.vue";

    export default Vue.extend({
        name: 'HomePage',
        props: {},
        data(): { info: { phone: string } } {
            return {
                info: {
                    phone: '56934580660',
                },
            };
        },
        methods:{
            getNotification(snackbar:any){
                return {
                    type: snackbar.color == 'red' ? 'ERROR' : snackbar.color == 'warning' ? 'WARNING' : snackbar.color == 'info' ? 'NOINFOFOUND' : 'SUCCESS',
                    messages: typeof snackbar.text === 'string' ? [snackbar.text] : snackbar.text,
                    customPosition: true,
                    showXIcon: true
                }
            }
        },
        computed: {
            snackbar(): any {
                return (this as any).$store.state.snackbar;
            },
            whatsappPhone() {
                return 'https://wa.me/' + (this as any).info.phone;
            },
        },
        components: {
            RomaNotification
        }
    });
